import React from 'react';
import { useFormikContext } from 'formik';

interface Props {
  deps: unknown[];
}

// Formik does not re-run validation when the `validationSchema` prop changes.
// Mount this inside a Formik tree and pass the values that control which
// schema is active; it will trigger a re-validate whenever they change.
function RevalidateOnDeps({ deps }: Props) {
  const { validateForm } = useFormikContext();

  React.useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return null;
}

export default RevalidateOnDeps;
